
import { defineComponent } from "vue";
export default defineComponent({
  name: "MapMarker",
  props: {
    color: {
      type: String,
      default: "",
    },
    draggable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    Color(): string {
      return this.color || "currentColor";
    },
  },
});
